import React from 'react'
import {Flex} from '@components'
import {Button, Form, message, Spin, Icon} from 'antd'
import css from './index.css'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import {getLoginUser} from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'

import CommonTip from '@pages/SelfHelp/common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import {mkbz} from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'

@Form.create()
export default class Channel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mkbz: 'GD047',
            hjmc: '',
            loading: false,
            nextUrl: '',
            search: '',
            operable: true, // 是否显示环节
            nonOperationalData: {}, // 不可操作的数据

            dormitoryAllocation: '暂未分配',
            classAllocation: '暂未分配',
            isHjLinked: false,
        }
    }

    componentDidMount() {
        this.checkIsZzbdHjLinked();

        this.queryQztjAndYlhj(operable => {
            if (operable) {
                // this.updateZzbdBlzt()
                this.getDormitoryClassSituation();
            }
        })

    }

    //迎新现场已办理时迎新网站自动办理
    getDormitoryClassSituation = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        NHFetch('/zzbd/getDormitoryClassSituation', 'GET', {xsid}).then(res => {
            if (res?.code === 200 && res.data) {
                if (res.data.bjmc) {
                    this.setState({classAllocation: res.data.bjmc})
                }
                if (res.data.cwid) {
                    this.setState({dormitoryAllocation: res.data.cwxx})
                }
            }
        })
    }

    //迎新现场已办理时迎新网站自动办理
    updateZzbdBlzt = () => {
        let zzbdhjid = this.getQueryString('pkid')
        NHFetch('/zzbd/updateZzbdBlzt', 'GET', {zzbdhjid: zzbdhjid, hjdm: 'GD047'}).then(res => {
            if (res.data) {
                this.reloadMenu()
            }
        })
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = callback => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false
            })
            return
        }
        let zzbdhjid = this.getQueryString('pkid')
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', {xsid: xsid, zzbdhjid: zzbdhjid}).then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj']
                let ylhj = res.data['ylhj']
                let qzhj = res.data['qzhj']
                let nohj = res.data['nohj']
                this.setState({nonOperationalData: res.data})
                if (kfsj && kfsj['YXSJ'] != '1') {
                    this.setState({operable: false})
                }

                if (ylhj && ylhj.length > 0) {
                    this.setState({operable: false})
                }

                if (qzhj && qzhj.length > 0) {
                    this.setState({operable: false})
                }

                if (nohj) {
                    this.setState({operable: false})
                }

                if (callback) {
                    callback(this.state.operable)
                }
            }
        })
    }

    getQueryString = name => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = menuList => {
        let nextCount = 0
        let bz = this.state.mkbz
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC
                this.setState({hjmc: hjmc})
                nextCount = index + 1
                return
            }
        })
        let menu = menuList[nextCount]
        if (menu) {
            let hjdm = menu.HJDM
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm]
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = '/customLink'
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: ''
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    checkIsZzbdHjLinked = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getQueryString('pkid');

        NHFetch("/zzbd/checkIsZzbdHjLinked", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
            .then(res => {
                this.setState({ isHjLinked: res?.data });
            });
    };

    updateStatus = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getQueryString('pkid');
        let postData = {
            'zzbdhjid': zzbdhjid,
            'xsid': xsid
        }
        NHFetch('/zzbd/commonSaveLinkTransactionStatus', 'POST', postData)
            .then(res => {
                if (res) {
                    message.success("已确认办理");
                    this.reloadMenu();
                    this.setState({ isHjLinked: true });
                }
            });
    }

    render() {
        const { classAllocation, dormitoryAllocation } = this.state;

        return (
            <div style={{position: 'relative'}}>
                {this.state.operable ? (
                    <div>
                        <Flex className="w1180 mt-20" align="start">
                            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到"
                                       mkbz={this.state.mkbz} menuType="自助报到"/>
                            <Flex.Item className="page_con_r" styleName="">
                                <Breadcrumb noLine list={[{name: '首页', url: '/index'}, {name: '自助报到', url: '/register'}, {name: this.state.hjmc}]}/>
                                <div className="box">
                                    <Hint/>
                                    <TitleTop title="班级和宿舍分配情况" extra={false}/>
                                    <div className={css.titleSubTip}>
                                        <Icon type="info-circle" className={css.titleSubTipIcon}/>
                                        <span>完成前序环节且学院完成分班分寝发布后方可查看</span>
                                    </div>
                                    <div style={{textAlign: "center"}}>
                                        <br/><br/><br/><br/>
                                        <div style={{fontSize: '20px'}}>
                                            <b>班级分配情况：</b> <span
                                            style={{color: "red"}}>{this.state.classAllocation}</span>
                                        </div>
                                        <div style={{fontSize: '20px'}}>
                                            <b>宿舍分配情况：</b> <span
                                            style={{color: "red"}}>{this.state.dormitoryAllocation}</span>
                                        </div>
                                    </div>


                                    <div className="text-center mt-50">
                                        {!this.state.isHjLinked
                                            && (classAllocation && classAllocation != '暂未分配')
                                            && (dormitoryAllocation && dormitoryAllocation != '暂未分配')
                                            &&
                                        <Button
                                            onClick={() => this.updateStatus()}
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            确认知悉
                                        </Button>}
                                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                    </div>
                                </div>
                            </Flex.Item>
                        </Flex>
                        <Spin style={{position: 'absolute', top: '300px', left: '60%'}}
                              spinning={this.state.loading}/>{' '}
                    </div>
                    ) :
                    <CommonTip hjmc={'班级和宿舍分配情况'} key={'GD047'} mkbz="GD047" nonOperationalData={this.state.nonOperationalData}/>
                }
            </div>
        )
    }
}
